<script lang="ts">
    import LoadingPattern from 'hydria/components/LoadingPattern.svelte'
    import { gettext as _ } from 'hydria/services/gettext'
    import { simpleFetch, groups as ugroups } from 'hydria/services/session'
    import { onMount } from 'svelte'

    let loading: boolean | undefined = $state()
    let error: string | undefined = $state()
    let zstatus: any = $state()

    async function load() {
        loading = true
        error = undefined
        try {
            const r = await simpleFetch('GET', '/json/zone/1/zone-statuses')
            zstatus = r.data
        } catch (e) {
            error = 'Exception'
        }

        loading = false
    }
    onMount(() => {
        if ($ugroups.has('zone-management') && loading == null) {
            load()
        }
    })
</script>

{#if $ugroups.has('zone-management')}
    <div class="card">
        <div class="card-title text-primary">Zones sur les serveurs NSD</div>
        {#if loading !== false}
            <div class="card-body">
                <LoadingPattern pattern={['x', 'x', 'x', 'x']} />
            </div>
        {:else if error}
            <div class="card-body">Les données n’ont pas pu être chargées.</div>
        {:else}
            <div class="card-body">
                <table class="table mb-0">
                    <tbody>
                        <tr>
                            <th>{$_('Zone count')}</th>
                            <td class="text-end" style="font-feature-settings: 'ss01' 1, 'tnum' 1;">{zstatus.zone_count}</td>
                        </tr>
                        <tr>
                            <th>Zones ayant de l’info de présence NSD</th>
                            <td class="text-end" style="font-feature-settings: 'ss01' 1, 'tnum' 1;">{zstatus.status_count}</td>
                        </tr>
                        <tr>
                            <th>NSD : nombre de zones publiées</th>
                            <td class="text-end" style="font-feature-settings: 'ss01' 1, 'tnum' 1;">{zstatus.published_zones}</td>
                        </tr>
                        <tr>
                            <th>NSD : nombre de zones non-publiées</th>
                            <td class="text-end" style="font-feature-settings: 'ss01' 1, 'tnum' 1;">{zstatus.unpublished_zones}</td>
                        </tr>
                        <tr>
                            <th>Zones publiées, absente sur des serveurs NSD</th>
                            <td class="text-end" style="font-feature-settings: 'ss01' 1, 'tnum' 1;" class:text-error={zstatus.published_zones_missing_servers > 0}>{zstatus.published_zones_missing_servers}</td>
                        </tr>
                        <tr>
                            <th>Zones non-publiées, avec présence sur un serveur NSD</th>
                            <td class="text-end" style="font-feature-settings: 'ss01' 1, 'tnum' 1;" class:text-error={zstatus.unpublished_zones_extra_servers > 0}>{zstatus.unpublished_zones_extra_servers}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        {/if}
    </div>
{/if}
